import api from "../../api.js";

export async function mergeProfiles(payload) {
  const res = await api.post("/api/profiles/merge", payload);
  return res.data;
}
